<template>
  <div>
    <div class="uiBreadcrumb">
      <ul class="uiClrfix" v-if="lang == 'chs'">
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />首页</a>
        </li>
        <li><span>/</span><a class="cur">站点地图</a></li>
      </ul>
      <ul class="uiClrfix" v-else>
        <li>
          <a href="./"> <svg-icon icon-class="home-filling" />Home</a>
        </li>
        <li><span>/</span><a class="cur">Sitemap</a></li>
      </ul>
    </div>
    <div class="center">
      <div class="sitemap_main">
        <ul class="sitemap_box">
          <li
            v-for="(item, i) in navList"
            :key="i"
            @click="JumpTo(item)"
            class="sitemap_title"
          >
            <span v-if="lang == 'chs'">{{ item.name }}</span>
            <span v-else>{{ item.Ename }}</span>
            <span class="sitemap_p">></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Sitemap",
  data() {
    return {
      lang: "",
      navList: [
        { name: "首页", Ename: "Home Page", address: "homePage",Roter:'HomePage' },
        { name: "关于", Ename: "About", address: "about",Roter:'About' },
        {
          name: "投资企业",
          Ename: "Portfolio Companies",
          address: "portfolioCompanies",
          Roter:'PortfolioCompanies'
        },
        {
          name: "投资者登入",
          Ename: "Investor Login",
          address: "investorLogin",
          Roter:'InvestorLogin'
        },
        // { name: "员工登入", Ename: "Staff Login", address: "staffLogin",Roter:'StaffLogin' },
        { name: "工作机会", Ename: "Career", address: "career",Roter:'Career' },
        { name: "联系我们", Ename: "Contact Us", address: "contactUs",Roter:'ContactUs' },
      ],
    };
  },
  methods: {
    JumpTo(item) {
      let add = item.Roter;
      if (item.address) {
        this.aName = item.address;
      } else {
        this.aName = "homePage";
      }
      if (item.address == "investorLogin") {
        if(this.lang =='eng'){
        window.open("http://8.217.65.217:8081/login#lang=en");
        }else{
        window.open("http://8.217.65.217:8081/login#lang=cn");
        }
      } else if (item.address == "staffLogin") {
        window.location.href =
          "https://account.eastspider.com/login/info?param=MW29MUZhWBKQZEYlx9e7R1iRPVMQLVglKMvlGs5ztiFuGze-bAqkeJVxaQyNMK-gWvreiPka5VmK8FICzY-nDGI-14IF7P8p1k446-sR_lT851odWeTrYNA2Zeuvm0y4sJlvJzIc62LrkHFgacWQ-uu7ls7Tq-j2ABvkfk7oevDHPEkzQSqdMtlTeJY9vaIkVVC485SMpPigUYGUePlS3sv2fQ8wbFyrAw8Z3zftD4A6xVPhBkWhJwhU4Q2Mz2lLDDPIzKPRoWzCm9vr0DtlaC4VelWLv2gGHOgIDNvlSuhOrKuoobKOfaMpVSpB8wvOqlSeeJ7dM6Zc8bYkPzXqL3cLrsEh9k27wdy4yRarzOho-Co6UK7UWs5wlT7A-J3DavNlW1efZi0VOndVhd7UOK-INw_P3EeLlS5ZUyfTxiqakNW5WK34dw2PtyS5a9Dj7PS0C8cz71TkNakAN-vBdXXmylgRZ9PwiZtFs4PE4sMTFZZwZ72BDW9U2GBG5gwh";
      } else {
        this.$router.push({ name: add });
      }
    },
  },
  mounted() {
    let lang = sessionStorage.getItem("lang");
    if (lang) {
      this.lang = lang;
      this.$store.commit("setLang", lang);
    } else {
      this.lang = "chs";
      this.$store.commit("setLang", "chs");
    }
  },
  computed: {
    listenData() {
      return this.$store.state.lang;
    },
  },
  watch: {
    listenData(newVal) {
      this.lang = newVal;
    },
  },
};
</script>

<style scoped>
.uiBreadcrumb {
  width: 1200px;
  padding: 0 15px;
  margin: 15px auto;
  height: 19px;
}

.uiBreadcrumb ul li {
  float: left;
}

.uiBreadcrumb ul li:nth-child(1):hover a {
  color: #233a78;
}

.uiBreadcrumb ul li span {
  padding: 0 5px;
}

.uiBreadcrumb ul li a {
  color: #999;
  font-size: 14px;
}

.uiBreadcrumb ul li .cur {
  color: #333;
  font-size: 14px;
}
.center {
  width: 1200px;
  margin: auto;
  background: #fff;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.sitemap_main {
  margin-top: 30px;
  min-height: 260px;
  line-height: 27px;
  padding: 60px 230px 90px;
  font-size: 18px;
}
.sitemap_title {
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  border: 1px solid #ddd;
  color: #565867;
  background: #eee;
  cursor: pointer;
  margin-bottom: 20px;
}
.sitemap_title:hover {
  color: #007aff;
}
.sitemap_p {
  float: right;
  font-size: 24px;
}
</style>